import React, { useState, useRef } from 'react'
import Overlay from 'react-bootstrap/Overlay'
import Tooltip from 'react-bootstrap/Tooltip'
import { GolfPlayer, Lightning } from 'app/icons'
import { Trophy } from 'app/icons'
import { getPlayersGameScores } from 'components/play/playGameModel'
import * as Table from 'shared/TableContentControl'

const PlayersList = ({ game: { players }, showScore }) => {
  const gamePlayersScores = getPlayersGameScores({ players })
  const playersWithScores = players.map((player) => {
    const scoreInfo = gamePlayersScores.find((itm) => itm.id === player.user.id)
    return {
      ...player,
      totalScore: scoreInfo.totalScore,
      isGameWinner: scoreInfo.isGameWinner,
    }
  })
  return (
    <Table.Container>
      {playersWithScores.map((player) => (
        <Table.Row key={player.user.id}>
          <Player player={player} showScore={showScore} />
        </Table.Row>
      ))}
    </Table.Container>
  )
}

const Player = ({
  player: {
    totalScore,
    isOnline,
    isGameWinner,
    user: { username },
  },
  showScore,
}) => {
  const target = useRef(null)
  const [show, setShow] = useState(false)
  return (
    <>
      <Table.Item>
        <GolfPlayer />
        {username}
        {isOnline && (
          <>
            <span ref={target} onClick={() => setShow(!show)}>
              {' '}
              <Lightning />
            </span>
            <Overlay target={target.current} show={show} placement="right">
              {(props) => (
                <Tooltip id="overlay-example" {...props}>
                  {username} is online
                </Tooltip>
              )}
            </Overlay>
          </>
        )}
      </Table.Item>

      {showScore && (
        <>
          <Table.Item style={{ textAlign: 'right', padding: '0 0 0 .5rem' }}>
            {` ${totalScore}`}
          </Table.Item>
          <Table.Item style={{ textAlign: 'right', padding: '0 0 0 .5rem' }}>
            {isGameWinner && <Trophy />}
          </Table.Item>
        </>
      )}
    </>
  )
}

export default PlayersList
